var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',_vm._g(_vm._b({attrs:{"title":"Grant Cycle","icon":"fa-solid fa-arrow-rotate-left","icon-attrs":{rotation: 90}}},'modal',_vm.$attrs,false),_vm.$listeners),[_c('b-img',{staticClass:"d-block mx-auto",attrs:{"src":"/assets/images/grant-cycle.png","width":"490","height":"447","fluid":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }